<template>
  <nav v-if="applyData" class="report__menu menu-text-visible" ref="lnb">
    <ui-logo />
    <ul class="menu" :class="{'ab': isABPlan}">
      <router-link v-for="item in menus" :key="item.name" class="item"
        :to="{ name: isABPlan && item.name !== 'ab.list' ? '': item.name, params: routeParams }" tag="li"
        :class="getMenuItemClass(item)"
        @click.native="onClickRouter"
      >
        <a :disabled="(isABPlan && item.name !== 'ab.list') || (item.name === 'mine' && mineDisabled) " :target="item.name === 'mine' ? '_blank' : '_self'">
          <i class="icon" :class="getMenuItemClass(item, 'icon')"></i>
          <template v-if="!applyData.meta.isSPA && item.name === 'ab.list' && (applyData.meta.abCount || applyData.meta.abCountAllReport)">
            <i class="icon icon--sync"></i>
          </template>
          <span class="text font-roboto">{{ item.text }}</span>
        </a>
      </router-link>
    </ul>

    <div class="report__menu__claim-issue">
      <ul>
        <li v-if="!applyData.bLogin">
          <span v-if="isSupportRecapture && !isPeriodEndIsToday"
            class="recapture-mask"
            @mouseenter="onRecaptureMouseEnter"
            @mouseleave="onRecaptureMouseLeave">
            <ui-tooltip v-show="showRetakeDisabledTooltip" class="info-tooltip">
              {{ $t('lnb.claimIssue.reportImage.dateNotAvailable') }}
            </ui-tooltip>
          </span>
          <button class="btn--recapture" @click="onRetakeClick"
            :disabled="isShowRetakeLayer || !canRecapture || isDemo">
            <i class="icon icon--retake"></i>
            <span class="text" v-html="$t('lnb.claimIssue.retake.button')"></span>
          </button>
        </li>
        <li>
          <button @click="isShowClaimLayer = true" :disabled="isDemo" >
            <i class="icon icon--claim"></i>
            <span class="text" v-html="$t('lnb.claimIssue.claim.button')"></span>
          </button>
        </li>
      </ul>
    </div>

    <div class="report__menu__tab">
      <i class="icon icon--tab"
         @click.stop="onLnbMinimize"></i>
    </div>

    <dimmed v-if="useDimmed">
      <retake v-if="isShowRetakeLayer"
              :aid="applyData._id"
              @onCaptureSuccess="onCaptureSuccess"
              @closeLayer="onRetakeLayerClose"/>
      <claim v-if="isShowClaimLayer"
             @closeLayer="isShowClaimLayer = false"/>
    </dimmed>
  </nav>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { startOfDay, parse } from 'date-fns'
import Claim from '@/components/report/Claim'
import Retake from '@/components/report/Retake'
import Dimmed from '@/components/ui/Dimmed'
import UiTooltip from '@/components/ui/UiTooltip'
import { utcToLocalTimezone } from '@/libs/utils'
import UiLogo from '@/components/ui/UiLogo.vue'

export default {
  name: 'ReportMenu',
  components: {
    Claim,
    Retake,
    Dimmed,
    UiTooltip,
    UiLogo
  },
  data () {
    return {
      isShowClaimLayer: false,
      isShowRetakeLayer: false,
      bLogin: false,
      showRetakeDisabledTooltip: false,
      bAMP: false
    }
  },
  computed: {
    ...mapState([
      'layout',
      'applyData',
      'planData',
      'reportPeriod',
      'isABPlan',
      'isDemo',
      'totalReportCnt'
    ]),
    menus () {
      const bAMP = this.applyData.bAMP
      let menulist = [
        {
          name: 'heatmap-report',
          text: 'Reporting Heatmaps'
        },
        {
          name: 'analytics-report',
          text: 'Analytics'
        },
        {
          name: 'referrers-report',
          text: 'Comparing Referrers'
        },
        {
          name: 'cta-report',
          text: 'Segmenting CTA'
        },
        {
          name: 'time-machine-report',
          text: 'Time Machine'
        },
        {
          name: 'ab.list',
          text: 'A/B Testing'
        },
        {
          name: 'funnel.list',
          text: 'Funnels'
        },
        {
          name: 'mine',
          text: 'Mine'
        }
      ]

      if (!this.planData || this.planData.planNumber < 4000) {
        menulist = menulist.filter(item => item.name !== 'time-machine-report')
      }

      if (bAMP) {
        // AMP 시 ab, funnel 제외
        menulist.pop()
        menulist.pop()
      }
      return menulist
    },
    currentRouteName () {
      return this.$route.name
    },
    routeParams () {
      return {
        aid: this.$route.params.aid
      }
    },
    isPeriodEndIsToday () {
      const periodEnd = startOfDay(parse(this.reportPeriod.end))
      const today = startOfDay(utcToLocalTimezone(new Date(), this.applyData.timezoneName))
      return periodEnd.getTime() === today.getTime()
    },
    isSupportRecapture () {
      const routeName = this.$route.name
      const targetRouteNames = [
        'heatmap-report',
        'referrers-report',
        'cta-report'
      ]
      return targetRouteNames.includes(routeName) ||
        (routeName === 'ab.view' && this.$route.params.viewType === 'heatmap')
    },
    canRecapture () {
      return !this.isCapturing && this.isSupportRecapture && this.isPeriodEndIsToday
    },
    useDimmed () {
      return this.isShowClaimLayer || this.isShowRetakeLayer
    },
    mineDisabled () {
      return this.totalReportCnt <= 0
    }
  },
  created () {
  },
  mounted () {
    this.$refs.lnb.addEventListener('transitionend', function (e) {
      let reportMenu = document.querySelector('.report__menu')
      if (this.layout) this.layout.lnbMinimize ? reportMenu.classList.remove('menu-text-visible') : reportMenu.classList.add('menu-text-visible')
    })
  },
  methods: {
    ...mapMutations([
      'setLnbMinimize',
      'setCaptureImageTimestamp'
    ]),
    getMenuItemClass (item, content) {
      const values = []
      const menuId = item.name.replace(/[.-].*$/, '')

      if (content === 'icon') { values.push(`icon_${menuId}`) }
      if (this.$route.name.indexOf(menuId) === 0) {
        values.push('on')
      }

      return values.join(' ')
    },
    onLnbMinimize () {
      this.setLnbMinimize()
    },
    onRetakeClick () {
      if (this.isShowRetakeLayer) return false
      this.isShowRetakeLayer = true
    },
    onCaptureSuccess () {
      this.setCaptureImageTimestamp(new Date().getTime())
      this.onRetakeLayerClose()
    },
    onRetakeLayerClose () {
      this.isShowRetakeLayer = false
    },
    onRecaptureMouseEnter () {
      if (!this.canRecapture && this.isSupportRecapture && !this.isPeriodEndIsToday) {
        this.showRetakeDisabledTooltip = true
      }
    },
    onRecaptureMouseLeave () {
      this.showRetakeDisabledTooltip = false
    },
    onClickRouter (e) {
      if (this.mineDisabled) {
        e.preventDefault()
        e.stopPropagation()
      }
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss">
.report__menu {
  background-color: #1b1b1d;
  position: relative;
  z-index: 20;

  .menu {
    margin-top: 88px;
    margin-left: 12px;

    &.ab {
      margin-top: 0;
    }

    .item {
      position: relative;
      height: 26px;
      margin-top: 22px;

      &.on {
        &:after{
          display: inline-block;
          content: '';
          width: 3px;
          height: 100%;
          background-color: $brandColor2;
          position: absolute;
          top: 0;
          right: 0;
        }

        .text {
          color: #fff;
        }
      }

      a {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        .icon {
          &.icon--sync {
            position: absolute;
            left: 15px;
            bottom: -1px;
          }
        }

        &:hover:not([disabled]) {
          .text {
            color: #fff;
          }
        }
      }

      .text {
        font-size: 14px;
        color: #999;
        margin-left: 12px;
        /*width: 150px;*/
        display: none;
        font-weight: 500;
      }

      .icon--beta {
        margin-left: 8px;
      }

      a[disabled] {
        opacity: 0.3;
        cursor: default;
      }
    }
  }

  .report__menu__claim-issue {
    padding-top: 5px;
    margin-top: 26px;
    border-top: 1px solid #333;

    z-index: 2;

    ul {
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        justify-content: center;
        position: relative;
        button {
          font-weight: 500;
        }
      }
    }

    .recapture-mask {
      position: absolute;
      width: 186px;
      height: 38px;
      top: 10px;

      .info-tooltip {
        top: -60px;
      }
    }

    button {
      overflow: hidden;
      background-color: #000000;
      width: 186px;
      height: 38px;
      border: solid 1px #444444;
      border-radius: 19px;
      position: relative;
      font-size: 14px;
      color: #aaaaaa;
      text-align: right;

      padding-right: 15px;
      box-sizing: border-box;
      margin-top: 10px;

      transition: width 0.3s;

      &:hover{
        &:after{
          display: block;
          content: '';
          width: 100%;
          height: 100%;
          background-color: #fff;
          position: absolute;
          top:0;
          left:0;
          opacity: 0.12;
        }
      }

      &[disabled] {
        opacity: 0.3;
        pointer-events: none;
        &:after {
          display: none;
        }
      }

      .icon {
        position: absolute;
        top: 50%;
        left: 15px;
        transform: translateY(-50%)
      }

      .text {
        -webkit-animation: menuTextVisible 0.3s ease-in-out 0s;
        animation: menuTextVisible 0.3s ease-in-out 0s;
      }
    }
  }

  .report__menu__tab{
    position: absolute;
    top: 73px;
    right: -10px;
    width: 10px;
    height: 38px;
    background: url('../../assets/img/report_menu_tab.svg') no-repeat 0 0;
  }

  &.menu-text-visible .menu .item .text {
    display: inline-block;
    -webkit-animation: menuTextVisible 0.3s ease-in-out 0s;
    animation: menuTextVisible 0.3s ease-in-out 0s;
  }
}
@keyframes menuTextVisible {
  0% {
    text-indent: -150px;
    opacity: 0;
  }
  65% {
    opacity: 0;
  }
  100% {
    text-indent: 0;
    opacity: 1;
  }
}
@-webkit-keyframes menuTextVisible {
  0% {
    text-indent: -150px;
    opacity: 0;
  }
  65% {
    opacity: 0;
  }
  100% {
    text-indent: 0;
    opacity: 1;
  }
}
</style>
